import React from 'react';
import { useAppContext } from './AppContext';

export default function Toast() {
  const { toast } = useAppContext();
  if (!toast) return null;
  return (
    <div
      className={`toast toast-${toast.type}`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      tabIndex={0}
      style={{
        position: 'fixed',
        top: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        minWidth: 220,
        maxWidth: 400,
        padding: '1rem 1.5rem',
        borderRadius: 8,
        background:
          toast.type === 'error' ? '#e74c3c' : toast.type === 'success' ? '#27ae60' : '#2c3e50',
        color: '#fff',
        fontWeight: 500,
        boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
        textAlign: 'center',
        outline: 'none',
        fontSize: '1rem',
        letterSpacing: '0.01em',
        animation: 'fadeInDown 0.3s',
      }}
    >
      {toast.message}
    </div>
  );
}
